import React from "react";
import "jspdf-autotable";
import { useLocation, useParams } from "react-router";
import { GetListOfPMCAuditTrail, GetListOfPMCAuditTrailFilters } from "../../../services/ProgramService";
import { RenderAuditTrailResourceType } from "../../../utils/CommonGroupingItem";
import AuditTrailsTable from "../../common/AuditTrailsTable";
const AuditTrail = () => {
   const { search } = useLocation();
  const query = new URLSearchParams(search);

  const queryVersionId = query.get("versionId");
  const queryProgrammeId = query.get("programmeId");
  const {id} = useParams()

  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"]

  return (
    <AuditTrailsTable
      apiFunction={GetListOfPMCAuditTrail}
      apiParams={{action_id: id || queryProgrammeId,nested_action_id : queryVersionId}}
      columnsToShow={columnsToShow}
      filterArrApi={GetListOfPMCAuditTrailFilters}
      actionId={id}
      exportFileName={"PMC_AuditTrails"}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderAuditTrailResourceType}
    />
  )
}
export default AuditTrail;
